import {
  Connection,
  LAMPORTS_PER_SOL,
  RecentPrioritizationFees,
} from '@solana/web3.js'
import { DEFAULT_PRIORITY_FEE_LEVEL, PRIORITY_FEE_KEY } from './constants'
import { toContextTuplesString } from './logging'

export const getFeeEstimate = async (connection: Connection) => {
  // check if it's not node env exception for api
  let storedPriorityFeeLvl: number = DEFAULT_PRIORITY_FEE_LEVEL.value
  if (typeof localStorage !== 'undefined') {
    const rawPriorityFee = localStorage.getItem(PRIORITY_FEE_KEY.key)
    const parsedPriorityFee = Number(rawPriorityFee)
    if (rawPriorityFee != null && !Number.isNaN(parsedPriorityFee)) {
      storedPriorityFeeLvl = parsedPriorityFee
    }
  }

  const defaultFee = 10000
  const fallbackFeeEstimate = storedPriorityFeeLvl === 0 ? 1 : defaultFee

  try {
    const response = await fetch(connection.rpcEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        method: 'getRecentPrioritizationFees',
        jsonrpc: '2.0',
        params: [
          ['JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4'],
          { percentile: storedPriorityFeeLvl },
        ],
        id: '1',
      }),
    })
    if (!response.ok) {
      console.error(
        `failed estimation calculation: ${toContextTuplesString({
          status: response.status,
          response: await response.text(),
          storedPriorityFeeLvl,
        })}`,
      )
      return fallbackFeeEstimate
    }
    const { result: recentPrioritizationFees } = (await response.json()) as {
      result: RecentPrioritizationFees[]
    }
    // compute budget unit price is in micro lamports.
    // 0.001 * 10**9 is very small.
    // Calculate average of top 100 fees to get a competitive rate
    const fees =
      recentPrioritizationFees.map(
        ({ prioritizationFee }) => prioritizationFee,
      ) || []
    const topFees = fees.sort((a, b) => b - a).slice(0, 100)
    const averageFee =
      topFees.length > 0
        ? Math.ceil(topFees.reduce((sum, fee) => sum + fee, 0) / topFees.length)
        : 0

    //if option is none then do 1 micro lamport
    return storedPriorityFeeLvl === 0
      ? 1
      : Math.min(averageFee, LAMPORTS_PER_SOL * 0.0009)
  } catch (e) {
    console.error('failed estimation calculation', e)
    return fallbackFeeEstimate
  }
}
